module.exports = __webpack_public_path__ + "static/teleco_14-5f86acda243409a51295d853b99277ba.jpg";